export default __webpack_public_path__ + "static/media/design.8611da53.png";